import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { useHistory } from 'react-router-dom';
import useCustomerSettings from 'CustomHooks/useCustomerSettings';
import useGuiTranslations from '../Components/MultiLanguage/useGuiTranslations';

export default function TrialWarning(props) {
    const classes = useStyles();
    const history = useHistory();
    const getCustomerSettingsHookResponse = useCustomerSettings();
    const {accountStatus, remainingTimeInDays} = getCustomerSettingsHookResponse;
    const [translateGui] = useGuiTranslations();

    return (       
        <React.Fragment>
            {
                accountStatus == 'Trial' ?
                    <div className={classes.root}>
                        <span>
                            hhh
                            <Link href="#" onClick={() => {history.push('/Subscription'); props.closeMenu();}} style={{ marginRight: '2px' }}>
                                {translateGui(17)} {remainingTimeInDays}<br></br>{translateGui(18)}.
                            </Link>
                        </span>
                    </div>
                    : null
            }
        </React.Fragment>
    )
}

const useStyles = makeStyles({
    root: {
        position: 'fixed',
        bottom: '30px',
        padding: '10px',
        display: 'none',
        alignItems: 'flex-start',
        color: 'red',
        fontSize: '10px',
        display: 'flex',
        flexDirection: 'column',
        visibility: 'hidden',
    }
});